import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CarouselStyles } from "styles/style";
import { utils } from "supabase/content/utils.ts";

const STORAGE_BASE = "https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets";
const DEFAULT_THUMB = "a121c328-bc1d-4c80-91dc-76d932b9f155"
const EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];

// Thumbnail component that tries multiple extensions
const Thumbnail = ({ uuid, alt, ...props }) => {
  const [extIndex, setExtIndex] = useState(0);

  if (!uuid) uuid = DEFAULT_THUMB;

  // If uuid already has extension, use it directly
  const hasExtension = /\.[a-zA-Z0-9]+$/.test(uuid);
  const src = hasExtension
    ? `${STORAGE_BASE}/${uuid}`
    : `${STORAGE_BASE}/${uuid}${EXTENSIONS[extIndex]}`;

  const handleError = () => {
    // Try next extension
    if (!hasExtension && extIndex < EXTENSIONS.length - 1) {
      setExtIndex(extIndex + 1);
    }
  };

  return <CarouselStyles.MobileThumb src={src} alt={alt} onError={handleError} {...props} />;
};

export const VideoCard = ({ video, idx, table = "service" }) => {
  return (
    <CarouselStyles.VideoCardContainer>
      <CarouselStyles.MobileCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.MobileThumbWrapper>
          <Thumbnail uuid={video.thumbnail} alt={video.date} />
        </CarouselStyles.MobileThumbWrapper>
        <div tw="flex flex-col justify-between">
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </div>
      </CarouselStyles.MobileCard>

      {/* Desktop Layout */}
      <CarouselStyles.DesktopCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.VideoPlayer>
          <Thumbnail uuid={video.thumbnail} alt={video.date} />
        </CarouselStyles.VideoPlayer>

        <CarouselStyles.CardContentContainer>
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </CarouselStyles.CardContentContainer>
      </CarouselStyles.DesktopCard>
    </CarouselStyles.VideoCardContainer>
  );
}
